/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Close_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Close offline activation modal" |
*
* @param {Offline_Activation_Close_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_close_aria_label = /** @type {((inputs?: Offline_Activation_Close_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Close_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la boite de dialogue d'activation hors ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offline-Aktivierungsmodal schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi la modalità di attivazione offline")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть модальное окно активации в автономном режиме")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar el modo de activación sin conexión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭离线激活模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフラインアクティベーションモーダルを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑफ़लाइन सक्रियण मॉडल बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar modal de ativação offline")
	return /** @type {LocalizedString} */ ("Close offline activation modal")
});